import { render, staticRenderFns } from "./estatisticas-detalhe.vue?vue&type=template&id=0a424c9c&scoped=true"
import script from "./estatisticas-detalhe.vue?vue&type=script&lang=js"
export * from "./estatisticas-detalhe.vue?vue&type=script&lang=js"
import style0 from "./estatisticas-detalhe.vue?vue&type=style&index=0&id=0a424c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a424c9c",
  null
  
)

export default component.exports